import React from 'react';
import { Card, CardHeader, CardTitle, CardContent } from '../common/Card';
import { Progress } from '../common/Progress';
import Feedback from '../common/Feedback';
import { getCurrencySymbol } from '../../config/currencies';

export const MonthlyOverview = ({ totalSpent, budget, currency }) => {
    const percentageSpent = budget > 0 ? (totalSpent / budget) * 100 : 0;
    const isOverBudget = budget > 0 && totalSpent > budget;
    const currencySymbol = getCurrencySymbol(currency || 'USD');
    console.log(budget)
    
    return (
        <Card>
            <CardHeader>
                <CardTitle>Monthly Overview</CardTitle>
                {budget === 0 && (
                    <p className="text-sm text-gray-500">
                        Set a monthly budget in settings to track your spending
                    </p>
                )}
            </CardHeader>
            <CardContent>
                <div className="flex justify-between items-end mb-2">
                    <div className="text-2xl font-bold">
                        <span className={isOverBudget ? 'text-red-500' : ''}>
                            {currencySymbol}{totalSpent.toFixed(2)}
                        </span>
                        {budget > 0 && (
                            <span className="text-sm font-normal text-gray-500"> / {currencySymbol}{budget.toFixed(2)}</span>
                        )}
                    </div>
                    {budget > 0 && <div className="text-sm text-gray-500">Budget</div>}
                </div>
                {budget > 0 && (
                    <>
                        <Progress 
                            value={Math.min(percentageSpent, 100)} 
                            className={`h-2 mb-2 ${isOverBudget ? 'bg-red-100' : ''}`}
                        />
                        <div className="flex justify-between text-sm">
                            <div className={isOverBudget ? 'text-red-500' : 'text-gray-500'}>
                                {isOverBudget ? 'Over Budget' : 'Spent'}
                            </div>
                            <div className={isOverBudget ? 'text-red-500' : 'text-gray-500'}>
                                {percentageSpent.toFixed(1)}%
                            </div>
                        </div>
                    </>
                )}
                <Feedback 
                    prompt="How can we improve the monthly overview?"
                    source="monthly_overview"
                    onSubmit={(feedback) => {
                        console.log('Feedback received:', feedback);
                        // Handle feedback submission
                    }}
                />
            </CardContent>
        </Card>
    );
};